import React, { useState } from 'react'
import './Grid.css'
import GridItem from './GridItem'
import PROJECTS_DATA from './projects.data'

const Grid = () => {

    const [projectsData, setProjectsData] = useState(PROJECTS_DATA)

    return (
        <div className="gallery">
            {
                projectsData.map((project) => <GridItem project={project} key={project.id} />)
            }
        </div>
    )
}

export default Grid